import React from 'react';
import { ImageSlot } from './ImageSlot';

interface ImageSlotGridProps {
    label: string;
    images: string[] | undefined | null;
    maxImages: number;
    onImageAdd: (index: number, file: File) => void;
    onImageRemove: (index: number) => void;
    accept?: string;
    disabled?: boolean;
    required?: boolean;
    slotWidth?: string;
    slotHeight?: string;
    className?: string;
    description?: string;
}

export const ImageSlotGrid: React.FC<ImageSlotGridProps> = ({
    label,
    images,
    maxImages,
    onImageAdd,
    onImageRemove,
    accept = "image/*",
    disabled = false,
    required = false,
    slotWidth = "150px",
    slotHeight = "120px",
    className = "",
    description
}) => {
    // Đảm bảo images luôn là một mảng hợp lệ
    const safeImages = (() => {
        if (Array.isArray(images)) {
            return images;
        }
        if (typeof images === 'string') {
            // Nếu string rỗng hoặc null/undefined
            if (!images) {
                return [];
            }

            // Thử parse JSON trước
            try {
                const parsed = JSON.parse(images);
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                // Nếu không phải JSON, coi như URL đơn lẻ
                return [images];
            }
        }
        return [];
    })();

    // Tạo array với số lượng slots cố định
    const slots = Array.from({ length: maxImages }, (_, index) => ({
        index,
        imageUrl: safeImages[index] || null
    }));

    const handleImageSelect = (index: number, file: File) => {
        onImageAdd(index, file);
    };

    const handleImageRemove = (index: number) => {
        onImageRemove(index);
    };

    return (
        <div className={`mb-4 ${className}`}>
            <label className="block text-sm font-medium text-gray-700 mb-2">
                {label} {required && <span className="text-red-500">*</span>}
                <span className="text-xs text-gray-500 ml-2">
                    ({safeImages.filter(img => img).length}/{maxImages} ảnh)
                </span>
            </label>


            {description && (
                <p className="text-xs text-gray-600 mb-3">{description}</p>
            )}

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 image-slot-grid">
                {slots.map((slot) => (
                    <ImageSlot
                        key={slot.index}
                        imageUrl={slot.imageUrl || undefined}
                        onImageSelect={(file) => handleImageSelect(slot.index, file)}
                        onImageRemove={slot.imageUrl ? () => handleImageRemove(slot.index) : undefined}
                        accept={accept}
                        disabled={disabled}
                        width={slotWidth}
                        height={slotHeight}
                        placeholder={`Ảnh ${slot.index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};
